// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Dropdown, Menu, message } from 'antd';
import { YIcon, useModal, YModalProps } from '@ywfe/ywd';
import { SendProblem } from '@components/sendProblem';
import { ChangePassword } from './changePassword';
import { HeaderAvatarStyle, AuthUserActionStyle } from './styles';
import { delCookie } from '../utils/base';
import { NavItemStyle, NavIconItemStyle } from '../components/styles';
import { useGetAPI11940, usePostAPI17320 } from '../generated/api';

export const menuStyle = {
  display: 'flex',
  alignItems: 'center',
};
export const User: React.FC = () => {
  const { show, hide } = useModal();
  const [headIcon, setHeadIcon] = useState('');

  const { fetchAPI11940Data } = useGetAPI11940();
  const { fetchAPI17320Data } = usePostAPI17320();

  let form: any;
  const goToLogin = () => {
    if (typeof window === 'undefined') {
    } else {
      window.localStorage.removeItem('isGray');
      window.location.href = '/login';
    }
  };

  const gotoLoginOut = async () => {
    const res = await fetchAPI11940Data();
    res && message.success('退出成功！');
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('token', '');
      window.localStorage.setItem('userName', '');
      window.localStorage.setItem('userPhone', '');
      window.localStorage.setItem('isGray', '');
      window.localStorage.setItem('grayParams', '');
      delCookie('yowantId');
      goToLogin();
    }
  };

  const onChangePassword = (f: any) => {
    form = f;
  };

  const args = {
    title: '修改密码',
    size: 'small',
    content: () => <ChangePassword onChange={onChangePassword} />,
    onOk: async () => {
      try {
        if (form) {
          const data = await form.validateFields();
          const reg = new RegExp(/(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*])[a-z\d#@!~%^&*]{8,}/i);
          if (!reg.test(data.newPassword)) {
            message.info('密码至少8位，要求必须字母、数字、特殊符号（英文版本：~!@#$%^&*）！');
            return;
          }
          const res = await fetchAPI17320Data({
            userPhone: data.userPhone || '',
            newPasswd: (window as any).md5(data.newPassword || ''),
          });
          if (res) {
            message.success('修改成功！');
            hide();
          }
        } else {
          message.info('请输入');
        }
      } catch (error) {
        console.log(error);
      }
    },
  };

  useEffect(() => {
    const userInfos = JSON.parse(localStorage.getItem('yun_userInfos') || '{}');
    if (userInfos.headIcon) {
      setHeadIcon(userInfos.headIcon);
    }
  }, []);

  const menu = (
    <Menu>
      <Menu.Item>
        <SendProblem inMenu isIcon={1} />
      </Menu.Item>
      <Menu.Item onClick={() => show(args as YModalProps)}>
        <div style={menuStyle}>
          <img
            style={{ width: 16, height: 16, marginRight: 8 }}
            src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/synergy/home/icon-修改密码.png"
            alt=""
          />
          <div>修改密码</div>
        </div>
      </Menu.Item>
      <Menu.Item onClick={gotoLoginOut}>
        <div style={menuStyle}>
          <img
            style={{ width: 16, height: 16, marginRight: 8 }}
            src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/synergy/home/icon-退出登录.png"
            alt=""
          />
          <div style={{ color: '#F15A5A' }}>退出登录</div>
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <AuthUserActionStyle>
      <NavIconItemStyle>
        <div className="entry" onClick={() => window && (window as any).showBaseExport()}>
          <img style={{ width: 18, height: 18 }} src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/synergy/home/icon-导出记录.png" alt="" />
          <span className="name">导出记录</span>
        </div>
      </NavIconItemStyle>
      <NavItemStyle style={{ marginBottom: 16 }}>
        <Dropdown overlay={menu} arrow placement="topLeft">
          <div className="entry">
            <div>
              {headIcon ? <img className="user-head-img" src={headIcon} alt="" /> : <HeaderAvatarStyle icon={<YIcon name="UserOutlined" />} />}
              <div className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                {localStorage.getItem('userName') || ''}
              </div>
            </div>
          </div>
        </Dropdown>
      </NavItemStyle>
    </AuthUserActionStyle>
  );
};
